import { Http, HttpConfig } from '@zera-admin/classes'

import { CookieName } from 'app/shared/enums'
import { refresh } from './interceptors'

export const apiUrl = process.env.REACT_APP_ZERA_API

const http = new Http({
  origin: apiUrl,
  interceptors: {
    refresh,
  },
})
const httpDashboard = new Http({
  origin: apiUrl,
})
const httpAuth = new Http({
  origin: apiUrl,
})

export function request<T>(config: HttpConfig) {
  config.headers = {
    Authorization: 'Bearer ' + localStorage.getItem(CookieName.Token),
    ...config.headers,
    'Accept-Language': localStorage.getItem(CookieName.Language),
  }

  return http.request<T>(config)
}
export function requestDashboard<T>(config: HttpConfig) {
  config.headers = {
    Authorization: 'Bearer ' + localStorage.getItem(CookieName.Token),
    ...config.headers,
    'Accept-Language': localStorage.getItem(CookieName.Language),
  }

  return httpDashboard.request<T>(config)
}

export function requestAuth<T>(config: HttpConfig) {
  config.headers = {
    ...config.headers,
    'Accept-Language': localStorage.getItem(CookieName.Language),
  }

  return httpAuth.request<T>(config)
}

export default http
